import { createContext } from "react";

const AddHabitContext = createContext();

export default AddHabitContext;